import { Button } from 'rsuite';
import styles from './FormFooter.module.scss';

type FormFooterProps = {
  onCancel: () => void;
  onSubmit: () => void;
  submitLabel?: string;
  cancelLabel?: string;
  isSubmitting?: boolean;
};

export const FormFooter = ({
  onCancel,
  onSubmit,
  submitLabel = 'CRIAR MONITORAMENTO',
  cancelLabel = 'CANCELAR',
  isSubmitting = false,
}: FormFooterProps) => {
  return (
    <div className={styles.container}>
      <Button
        appearance="ghost"
        className={styles.cancelButton}
        onClick={onCancel}
        disabled={isSubmitting}
      >
        {cancelLabel}
      </Button>
      <Button
        appearance="primary"
        className={styles.submitButton}
        onClick={onSubmit}
        loading={isSubmitting}
      >
        {submitLabel}
      </Button>
    </div>
  );
};

